import { render, staticRenderFns } from "./Ytiframe.vue?vue&type=template&id=49bcc5cb&"
import script from "./Ytiframe.vue?vue&type=script&lang=js&"
export * from "./Ytiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports